import { defineMessages } from "react-intl";

export const messages = defineMessages({
  tunnelDevelopment: {
    id: "RjT+Vo",
    defaultMessage: "Tunnel - development",
    description: "label",
  },
  settings: {
    id: "BYGJ/j",
    defaultMessage: "Settings",
    description: "button label",
  },
  appDisabled: {
    id: "7u9Ep7",
    defaultMessage: "Disabled",
    description: "Label when app is disabled",
  },
});
